import React, { useState, useEffect, useMemo } from 'react';
import { HashRouter, Route, Switch, Redirect, BrowserRouter } from 'react-router-dom';
import './scss/style.scss';
import AuthContext,{OnlineStatusContext} from './Context';
import { Provider } from 'react-redux'
import store from './store';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


//Network Connection
// const PING_RESOURCE = "./ping.txt";
// const TIMEOUT_TIME_MS = 3000;
// const onlinePollingInterval = 10000;

// const timeout = (time ,promise) => {
//   return new Promise(function(resolve, reject) {
//     setTimeout(() => {
//       reject(new Error("Request timed out."));
//     }, time);
//     promise.then(resolve, reject);
//   });
// };

// const checkOnlineStatus = async () => {
//   const controller = new AbortController();
//   const { signal } = controller;

//   // If the browser has no network connection return offline
//   if (!navigator.onLine) return navigator.onLine;

//   //
//   try {
//     await timeout(
//       TIMEOUT_TIME_MS,
//       fetch(PING_RESOURCE, {
//         method: "GET",
//         signal
//       })
//     );
//     return true;
//   } catch (error) {
//     // Error Log
//     console.error(error);

//     // This can be because of request timed out
//     // so we abort the request for any case
//     controller.abort();
//   }
//   return false;
// };


//APP.JS
const loading = (
  <div className="pt-3 text-center">
  <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
  )

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const CreatePassword = React.lazy(()=> import('./views/CreatePassword/CreatePassword'))
const Success = React.lazy(()=> import('./views/Success/Success'))
const ForgotPassword = React.lazy(() => import('./views/pages/ForgotPassword/ForgotPassword'))


const App = (props) => { 

      const dispatch = useDispatch()
      const [loginCredentials, setloginCredentials] = useState(false)


      const contextConst = useMemo(() => ({

            signIn: (data) => {
            
              console.log("datauserdata",data)
              localStorage.setItem("userData", JSON.stringify(data))
              dispatch({ type: "userdata", payload: data})
              setloginCredentials(true)
            
            },
            signOut: () => {
              
              dispatch({ type: 'logout' })
              localStorage.removeItem("userData")
              setloginCredentials(false)

            },

      }))

 

      const isAuthenticated = () => {


            //write your condition here
            var tempUserData = localStorage.getItem('userData')
            var userData=JSON.parse(tempUserData)
            console.log("UserData",userData)

            dispatch({ type: "userdata", payload: userData})
            // if(Object.keys(permission).length === 0 && userData != null ) {
            //   dispatch({ type: "userdata", payload: userData})
            // }

            if (userData != null && userData.data != undefined && userData.data !=null)
            {
              global.profileInfo=userData
              return true;
            }
            else{
              return false;
              
            }
          
      }

  
      const AuthenticatedRoute = ({ component: Component, ...rest }) => (
            
            <Route {...rest} render={(props) => (
              isAuthenticated()
              ? <Component {...props} />
              : <Redirect to='/login'/>      
              )} />

      )


      const UnauthenticatedRoute = ({ component: Component, ...rest }) => (

            <Route {...rest} render={(props) => (
              !isAuthenticated() 
              ? <Component {...props} />
              : <Redirect to='/' />
              )} />

      );

 

      return (

            <Provider store={store}>
            <AuthContext.Provider value={contextConst}>

            <BrowserRouter basename={'/admin'}>
            <React.Suspense fallback={loading}>
            <Switch>
            {/* <UnauthenticatedRoute exact path="/login" name="Login Page" component={Login} /> */}
            
            {/* <UnauthenticatedRoute exact path="/menubar" name="Menubar Page" component={Menubar}/> */}


            <UnauthenticatedRoute exact path="/login" name="Login Page" component={Login} />
            <UnauthenticatedRoute exact path="/createpassword" name="Create Password" component={CreatePassword} />
            <UnauthenticatedRoute exact path="/success" name="Success" component={Success} />
            <UnauthenticatedRoute exact path="/forgotPassword" name="Forgot Password" component={ForgotPassword} />


            {/* <Route exact path="/register" name="Register Page" element={<Register />} />
            <Route exact path="/menubar" name="Menubar Page" element={<Menubar />} />
            <Route exact path="/search" name="Search Page" element={<Search />} />
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} /> */}


            <AuthenticatedRoute path="/" name="Home" component={DefaultLayout} />
     

            {/* <Route path="/" name="Home" render={props => <TheLayout {...props}/>} /> */}
            </Switch>
            </React.Suspense>
            </BrowserRouter>
            <ToastContainer position='top-right' autoClose={3000} closeButton={false} hideProgressBar={true} />

            </AuthContext.Provider>
            </Provider>
        );

}


export default App;